import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <button
      data-testid="theme-toggle"
      onClick={toggle}
      aria-label="Toggle theme"
      className="h-10 w-10 flex items-center justify-center rounded-full border border-border/60 bg-card/60 hover:bg-secondary transition-colors"
    >
      {theme === "dark" ? (
        <Sun size={18} strokeWidth={1.6} />
      ) : (
        <Moon size={18} strokeWidth={1.6} />
      )}
    </button>
  );
}
